import Vue from 'vue'
import moment from 'moment'
moment.locale(process.env.VUE_APP_I18N_LOCALE ?? 'en')


export const time = (value: string|Date, format: string = 'LT') => {
    return value === undefined ? '' : moment(value).format(format)
}
Vue.filter('time', time)


export const date = (value: string|Date, format: string = 'D MMM YYYY') => {
    return value === undefined ? '' : moment(value).format(format)
}
Vue.filter('date', date)


export const datetime = (value: string|Date, format: string = 'D MMMM YYYY \\o\\m HH:mm') => {
    return value === undefined ? '' : moment(value).format(format)
}
Vue.filter('datetime', datetime)


export const date_short = (value: string|Date, format: string = 'L') => {
    return value === undefined ? '' : moment(value).format(format)
}
Vue.filter('date_short', date_short)


export const date_long = (value: string|Date, format: string = 'LL') => {
    return value === undefined ? '' : moment(value).format(format)
}
Vue.filter('date_long', date_long)


export const from_now = (value: string|Date) => {
    return value === undefined ? '' : moment(value).fromNow()
}
Vue.filter('from_now', from_now)


export const calendar = (value: string|Date) => {
    return value === undefined ? '' : moment(value).calendar()
}
Vue.filter('calendar', calendar)


export const day_of_week = (value: number) => {
    return value === undefined ? '' : moment(value).day()
}
Vue.filter('day_of_week', day_of_week)
